import React, { useState, useEffect } from "react";
import axios from "axios";
import { useLocation, useNavigate } from "react-router-dom";
import "../../../styles/admins/rooms/book_room.css";
import GuestModal from "../invoices/guest";

const EditBooking = (props) => {
  const location = useLocation();
  const navigate = useNavigate();
  const [guests, setGuests] = useState([]);
  const [rooms, setRooms] = useState([]);
  const [shiftingRoom, setShiftingRoom] = useState(null);

console.log(location.state.roomData);

  useEffect(() => {
    const storedRooms = localStorage.getItem("rooms");
    if (storedRooms) {
      setRooms(
        JSON.parse(storedRooms).filter(
          (e) => e.room_id !== location.state.bookingDetails.room_id
        )
      );
    } else {
      axios
        .get(`https://api.dectwinhotel.com/api/${props.id}_rooms/rooms`)
        .then((response) => {
          localStorage.setItem("rooms", JSON.stringify(response.data));
          setRooms(
            response.data.filter(
              (e) =>
                e.room_id !== location.state.bookingDetails.room_id &&
                e.availability_status === 1
            )
          );
        })
        .catch((error) => {
          if (error.code === "ECONNABORTED") {
            window.location.reload();
          }
        });
    }
  }, [props.id, location.state.bookingDetails.room_id]);

  useEffect(() => {
    const fetchGuests = async () => {
      const allGuests = JSON.parse(localStorage.getItem("guests"));
      const ids = JSON.parse(location.state.bookingDetails.guest_ids).id;
      const addedGuests = [];

      for (const id of ids) {
        const guest = allGuests.find((g) => g.id === id);
        if (guest) {
          addedGuests.push(guest);
        } else {
          try {
            const response = await axios.get(
              `https://api.dectwinhotel.com/api/${props.id}_guests/guests/${id}`
            );
            if (response.status === 200) {
              addedGuests.push(response.data[0]);
            }
          } catch (err) {
            console.error(err);
          }
        }
      }
      setGuests(addedGuests);
    };

    fetchGuests();
  }, [location.state.bookingDetails.guest_ids, props.id]);

  const [showGuestModal, setShowGuestModal] = useState(false);

  const getCurrentDateTime = () => {
    const now = new Date();
    const year = now.getFullYear();
    const month = String(now.getMonth() + 1).padStart(2, "0");
    const day = String(now.getDate()).padStart(2, "0");
    const hours = String(now.getHours()).padStart(2, "0");
    const minutes = String(now.getMinutes()).padStart(2, "0");

    return `${year}-${month}-${day}T${hours}:${minutes}`;
  };

  const [formData, setFormData] = useState({
    booking_id: location.state.bookingDetails.booking_id,
    guest_data: location.state.bookingDetails.guest_ids,
    room_id: location.state.bookingDetails.room_id,
    room_no: location.state.bookingDetails.room_no,
    from_date: location.state.bookingDetails.from_date || "",
    to_date:
      location.state.bookingDetails.to_date === "0000-00-00 00:00:00"
        ? getCurrentDateTime()
        : location.state.bookingDetails.to_date,
    no_of_stayers: location.state.bookingDetails.no_of_stayers || 1,
    total_amount: location.state.bookingDetails.total_amount || 0,
    advance_amount: location.state.bookingDetails.advance_amount || 0,
    remarks: "",
    food_price: location.state.bookingDetails.food_order_total,
    withOrWithout: "Without Tax",
    shift_with_tax: "Without Tax",
    shift_amount: 0,
  });

  const calculateDaysDifference = (from, to) => {
    if (!from || !to) return 0;
    const fromDate = new Date(from);
    const toDate = new Date(to);
    const timeDifference = toDate - fromDate; // Difference in milliseconds
    return Math.ceil(timeDifference / (1000 * 60 * 60 * 24)); // Convert to days
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => {
      const updatedFormData = { ...prev, [name]: value };

      // Calculate total amount when dates are updated
      if (name === "from_date" || name === "to_date") {
        const days = calculateDaysDifference(
          updatedFormData.from_date,
          updatedFormData.to_date
        );
        // const total = days * location.state.bookingDetails.total_amount;
        const total = days * location.state.roomData.price;
        updatedFormData.total_amount = days > 0 ? total.toFixed(2) : "";
      }

      return updatedFormData;
    });
  };

  // Handle change in number input
  const handleNumberChange = (e) => {
    let value = e.target.value;

    if (value === "" || /^\d*\.?\d*$/.test(value)) {
      if (e.target.name === "shift_amount") {
        setShiftingRoom({ ...shiftingRoom, price: value });
      }
      setFormData({ ...formData, [e.target.name]: value });
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    props.handleLoading();
    if (guests.length < 1) {
      props.handleToast({
        toastMsg: "Something went wrong! Please Add atleast one guest.",
        toastColor: "#FF0000",
      });
      return;
    }

    const guestIds = guests.map((guest) => guest.id);
    const guestNames = guests.map((guest) => guest.name);

    formData.guest_ids = JSON.stringify({ id: guestIds, name: guestNames });

    if (formData.withOrWithout === "With Tax") {
      formData.total_amount = parseFloat(
        ((formData.total_amount * 100) / 112).toFixed(2)
      );
    }

    try {
      const response = await axios.put(
        `https://api.dectwinhotel.com/api/${props.id}_bookings/edit-checkin`,
        formData
      );
      props.closeLoading();
      if (response.status === 201) {
        props.handleToast({
          toastMsg: "Check In Updated Successfully!!!",
          toastColor: "#4CAF50",
        });
        window.scrollTo({
          top: 0,
          behavior: "smooth",
        });
        navigate("/admin/rooms");
      } else {
        props.handleToast({
          toastMsg: "Something went wrong! Please check data or internet.",
          toastColor: "#FF0000",
        });
      }
    } catch (err) {
      props.closeLoading();
    }
  };

  const openGuestModal = () => setShowGuestModal(true);
  const closeGuestModal = () => setShowGuestModal(false);

  const addGuestToForm = (guest) => {
    setGuests([...guests, guest]);
  };

  const removeGuest = async (guestId) => {
    props.handleLoading();
    try {
      props.closeLoading();
      setGuests(guests.filter((guest) => guest.id !== guestId));
    } catch (err) {
      props.closeLoading();
    }
  };

  const roomShifting = async () => {
    props.handleLoading();
    if (shiftingRoom) {
      try {
        await axios.put(
          // `http://localhost:8090/api/${props.id}_bookings/shift-room`,
          `https://api.dectwinhotel.com/api/${props.id}_bookings/shift-room`,
          {
            shiftFrom: location.state.bookingDetails.room_id,
            shiftTo: shiftingRoom.room_id,
            table: `${props.id}_rooms`,
            bookId: location.state.bookingDetails.booking_id,
            shiftToRoom: shiftingRoom.room_number,
            shiftPrice:
              formData.shift_with_tax === "With Tax"
                ? parseFloat(((formData.shift_amount * 100) / 112).toFixed(2))
                : parseFloat(formData.shift_amount),
          }
        );
        props.closeLoading();
        localStorage.removeItem("rooms");
        navigate("/admin/rooms", { replace: true });
        props.handleToast({
          toastMsg: "Room Shifted Successfully!!!",
          toastColor: "#4CAF50",
        });
      } catch (err) {
        props.closeLoading();
        props.handleToast({
          toastMsg: "Something went wrong! Please check data or internet.",
          toastColor: "#FF0000",
        });
      }
    } else {
              props.closeLoading();

      props.handleToast({
        toastMsg: "Please Select a Room to Shift Guest",
        toastColor: "#FF0000",
      });
    }
  };


  return (
    <section style={{ padding: "1rem 0" }}>
      <div className="book-room-form">
        <h2>Edit Checkin Room No {formData.room_no}</h2>
        <form onSubmit={handleSubmit}>
          {guests.length > 0 &&
            guests.map((guest) => (
              <div key={guest.id} className="guest-entry">
                <label htmlFor="guest_name">Guest Name</label>
                <input
                  type="text"
                  name="guest_name"
                  placeholder="Guest Name"
value={guest?.name || 'NA'}
                  onChange={handleChange}
                  required
                />
                <button type="button" onClick={() => removeGuest(guest?.id)}>
                  Remove Guest
                </button>
              </div>
            ))}

          {guests.length > 0 && <br />}

          <button type="button" onClick={openGuestModal}>
            Add Guest
          </button>

          <label htmlFor="from_date">From Date</label>
          <input
            type="datetime-local"
            name="from_date"
            value={formData.from_date}
            onChange={handleChange}
            required
          />

          <label htmlFor="to_date">To Date</label>
          <input
            type="datetime-local"
            name="to_date"
            min={formData.from_date}
            value={formData.to_date}
            onChange={handleChange}
          />

          <label htmlFor="no_of_stayers">Number of Adult(s)</label>
          <select
            name="no_of_stayers"
            value={formData.no_of_stayers}
            onChange={handleChange}
            required
          >
            <option value="">Select Number of Adult(s)</option>
            {Array.from({ length: 8 }, (_, i) => i + 1).map((num) => (
              <option key={num} value={num}>
                {num}
              </option>
            ))}
          </select>

          <div className="form-group">
            <label htmlFor="total_amount">Total Amount</label>
            <div className="d-flex">
              <input
                type="text"
                name="total_amount"
                placeholder="Total Amount"
                maxLength={9}
                value={formData.total_amount}
                onChange={handleNumberChange}
                required
              />
              <select
                name="withOrWithout"
                value={formData.withOrWithout}
                onChange={handleChange}
                required
              >
                <option value="Without Tax">Without Tax</option>
                <option value="With Tax">With Tax</option>
              </select>
            </div>
          </div>

          <label htmlFor="paid_amount">Advance Amount</label>
          <input
            type="text"
            name="advance_amount"
            placeholder="Advance Paid"
            maxLength={7}
            value={formData.advance_amount}
            onChange={handleNumberChange}
            required
          />

          <label htmlFor="remarks">Remarks</label>
          <textarea
            name="remarks"
            placeholder="Add any remarks here"
            value={formData.remarks}
            onChange={handleChange}
          />

          <button type="submit">Edit Checkin Now</button>
        </form>
        {/* Room Shifting Code */}

        <h4 className="text-center">OR</h4>
        <h2>Shift Room</h2>

        <label>Select Room to Shift</label>
        <select
          value={shiftingRoom?.room_id || ""}
          onChange={(e) => {
            const selectedId = parseInt(e.target.value);
            const selectedRoom = rooms.find(
              (room) => room.room_id === selectedId
            );
            setShiftingRoom(selectedRoom);
            setFormData({
              ...formData,
              shift_amount:
                calculateDaysDifference(formData.from_date, formData.to_date) *
                (selectedRoom.price || 0),
            });
          }}
          required
        >
          <option value="">Select a Room</option>
          {rooms.map((allRoom) => (
            <option key={allRoom.room_id} value={allRoom.room_id}>
              Room No. {allRoom.room_number} - {allRoom.room_type}
            </option>
          ))}
        </select>

        <label>Room Amount</label>
        <div className="d-flex">
          <input
            type="text"
            name="shift_amount"
            placeholder="Total Amount"
            maxLength={9}
            value={
              calculateDaysDifference(formData.from_date, formData.to_date) *
              (shiftingRoom?.price || 0)
            }
            onChange={handleNumberChange}
            required
          />
          <select
            name="shift_with_tax"
            value={formData.shift_with_tax}
            onChange={handleChange}
            required
          >
            <option value="Without Tax">Without Tax</option>
            <option value="With Tax">With Tax</option>
          </select>
        </div>

        <button style={{ marginTop: "16px" }} onClick={roomShifting}>
          Shift Room Now
        </button>
      </div>
      {showGuestModal && (
        <GuestModal
          onClose={closeGuestModal}
          addGuestToForm={addGuestToForm}
          handleToast={props.handleToast}
          id={props.id}
          handleLoading={props.handleLoading}
          closeLoading={props.closeLoading}
        />
      )}
    </section>
  );
};

export default EditBooking;
